export const environments = {
  LOCAL_SERVER: 'LocalServer',
  LOCAL: 'Local',
  STAGING: 'Staging',
  PREPROD: 'Preprod',
  PRODUCTION: 'Production',
  SANDBOX: 'Sandbox'
}
